export const APP_ENV = process.env.NEXT_PUBLIC_ENVIRONMENT;
export const ORDER_SERVICE_API_BASE_URL = process.env.NEXT_PUBLIC_SM_API_HOST;
export const ORDER_SERVICE_API_URL = `${ORDER_SERVICE_API_BASE_URL}/api/v1/ams`;
export const PRODUCT_SERVICE_GRAPHQL_API_BASE_URL =
  process.env.NEXT_PUBLIC_PRODUCTS_GRAPHQL_API_BASE_URL;
export const GOOGLE_RECAPTCHA_SITEKEY = process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITEKEY;
export const BASE_PATH = process.env.NEXT_PUBLIC_APP_BASE_PATH;

export const CHARGEBEE_BASE_URL = process.env.NEXT_PUBLIC_CHARGEBEE_URL;
export const CHARGEBEE_CB_SITE = process.env.NEXT_PUBLIC_CHARGEBEE_CB_SITE;

export const HUBSPOT_BOOK_A_CALL_PARTIAL_FORM_GUID =
  process.env.NEXT_PUBLIC_HUBSPOT_BOOK_A_CALL_PARTIAL_FORM_GUID || "";

export const HUBSPOT_BOOK_A_CALL_FORM_GUID =
  process.env.NEXT_PUBLIC_HUBSPOT_BOOK_A_CALL_FORM_GUID || "";

export const PLASMIC_CMS_ID = process.env.NEXT_PUBLIC_PLASMIC_CMS_ID || "";
export const PLASMIC_CMS_PUBLIC_TOKEN = process.env.NEXT_PUBLIC_PLASMIC_CMS_PUBLIC_TOKEN || "";

export const isDev = () => APP_ENV === "development";
